// extracted by mini-css-extract-plugin
export default {"checkboxWrap":"checkboxWrap--o9SH3","settingsButton":"settingsButton--PXJnP","checkbox":"checkbox--c_Uz3"};